import EmptyState from './empty-state.default';

export default EmptyState;
